import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import TpClientPaymentItem from './TpClientPaymentItem';

export default class TpClientPaymentPrepaymentItem extends TpClientPaymentItem {

  static FieldsToShowInDataTable() {
    return [
      {
        label: TpClientPaymentItem.getSelectedCellHeader,
        orderById: '',
        data: TpClientPaymentItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'TP Client Payment ID',
        orderById: 'TpClientPaymentId',
        data: TpClientPaymentItem.GetDetailCellContent,
        minWidth: 20,
      },
      { label: 'Client', orderById: 'ClientName', data: TpClientPaymentItem.getClientCellContent, minWidth: 40 },
      {
        label: 'Payment Method',
        orderById: 'Type',
        data: 'Type',
        minWidth: 20,
      },
      {
        label: 'Entry Date',
        orderById: 'EntryDateUtc',
        data: 'EntryDateUtc',
        minWidth: 40,
      },
      {
        label: 'Payment Reference #',
        orderById: 'CheckNumber',
        data: TpClientPaymentItem.getPaymentReferenceCellContent,
        minWidth: 20,
      },
      { label: 'Amount Paid', orderById: 'AmountPaid', data: 'AmountPaid', minWidth: 20 },
      { label: 'Remaining Balance', orderById: 'Balance', data: 'Balance', minWidth: 20 },
      {
        label: 'Reversed?',
        orderById: 'IsReversed',
        data: (item) => JsxHelper.YesNo(item.IsReversed),
        minWidth: 20,
      },
      {
        label: ' ',
        orderById: '',
        data: TpClientPaymentItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }
}
